export enum ErrorMessages {
  patternRule = 'patternRule',
  requiredRule = 'requiredRule',
}

export interface FormError {
  errors: ErrorMessages[];
  errorMessages: {
    [K in ErrorMessages]?: string;
  };
  hasError: boolean;
  isTouched: boolean;
}
